import { API_BASE_URL } from '@/lib/constants';
import httpClient from '@/api/httpClient';
import { useQuery } from '@tanstack/react-query';
import {
  PersonsResponse,
  PostProfileProblemRequestPayload,
  PostProfileProblemResponse,
  UpdateProfileRequestPayload,
  UpdateProfileResponse,
} from '@/api/profiles.model';

const PROFILES_KEY = 'profiles';

const getProfilesFn = async (): Promise<PersonsResponse> => {
  const response = await httpClient.get(`${API_BASE_URL}`);
  return response?.data as PersonsResponse;
};

const useProfiles = () => {
  return useQuery<PersonsResponse, Error>({
    queryKey: [PROFILES_KEY],
    queryFn: async () => {
      const response = await getProfilesFn();
      return response;
    },
  });
};

const updateProfileFn = async (
  data: UpdateProfileRequestPayload,
): Promise<UpdateProfileResponse> => {
  const response = await httpClient.post(`${API_BASE_URL}/update-person`, { data });
  return response?.data as UpdateProfileResponse;
};

const postProfileProblem = async (
  data: PostProfileProblemRequestPayload,
): Promise<PostProfileProblemResponse> => {
  const response = await httpClient.post(`${API_BASE_URL}/profile-problem`, { data });
  return response?.data as PostProfileProblemResponse;
};

export { getProfilesFn, useProfiles, updateProfileFn, postProfileProblem };
